<template>
<div>

    <p>Click <a href="https://stats.uptimerobot.com/ZrV89sM1jA">here</a>!</p>

</div>
</template>

<script>
export default {
name: "Status"
}

window.location = "https://stats.uptimerobot.com/ZrV89sM1jA";

</script>

<style scoped>

</style>